import { ContextPanelContent } from './context-panel-content';
import { lang } from '@lang';

import type { JSX } from "react";

export const DesignerOptionsPanel = (): JSX.Element => {
	return <ContextPanelContent title={lang.contextPanels.title.designerOptions}>
		<></>
	</ContextPanelContent>;
};
